module.exports = __webpack_public_path__ + "static/media/YF12_1.cced7faf.jpg";